var BasketPlugin = /** @class */ (function () {
    function BasketPlugin() {
    }
    return BasketPlugin;
}());
export { BasketPlugin };
